import React from 'react'
import SuccessMessageUI from '../../../../widgets/form/SuccessMessageUI'
import ErrorMessageUI from '../../../../widgets/form/ErrorMessageUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import ButtonUI from '../../../../widgets/action/ButtonUI'
import './MoveToCsModal.css'

const MoveToCsModalUI = ({
  context,
  loan,
  moveMode,
  onCancelClick,
  selectedFileCode,
  dueDate,
  onDueDateChange,
  submitted,
  successMsg,
  errorList,
  onSubmitClick
}) => {
  if (!moveMode) return null

  // Get the file title for display
  const getFileTitle = () => {
    let fileTitle = selectedFileCode

    if (loan.fileUploadList) {
      const file = loan.fileUploadList.find(f => f.fileCode === selectedFileCode)
      if (file) fileTitle = file.fileTitle
    }

    if (!fileTitle && loan.fileUpload2List) {
      const file = loan.fileUpload2List.find(f => f.fileCode === selectedFileCode)
      if (file) fileTitle = file.fileTitle
    }

    if (!fileTitle && loan.fileUpload3List) {
      const file = loan.fileUpload3List.find(f => f.fileCode === selectedFileCode)
      if (file) fileTitle = file.fileTitle
    }

    return fileTitle || selectedFileCode
  }

  return (
    <div className='move-to-cs-modal-overlay'>
      <div className='move-to-cs-modal-container'>
        <div className='move-to-cs-modal-header'>
          <h3>Move to Condition Subsequent</h3>
          <button className='move-to-cs-modal-close' onClick={onCancelClick}>×</button>
        </div>

        <div className='move-to-cs-modal-body'>
          <div className='g_m_bottom_100'>
            <p className='g_m_bottom_50'>
              You are moving <strong>{getFileTitle()}</strong> from Condition Precedent to Condition Subsequent.
            </p>
            <p className='g_muted' style={{ fontSize: '14px' }}>
              Please set a due date for this document in CS.
            </p>
          </div>

          <div className='g_m_bottom_100 move-to-cs-date-wrapper'>
            <InputDateUI
              context={context}
              name='dueDate'
              label='Due Date'
              required={true}
              selectedDateISO={dueDate}
              onChange={onDueDateChange}
              help='Select the due date for this CS document'
              error={errorList && errorList.length > 0}
            />
          </div>

          <SuccessMessageUI show={successMsg} message={successMsg} />
          <ErrorMessageUI errorList={errorList} />
        </div>

        <div className='move-to-cs-modal-footer'>
          <ButtonUI
            label='Cancel'
            onClick={onCancelClick}
            className='g_m_right_50'
            disabled={submitted}
          />
          <ButtonUI
            label='Move to CS'
            onClick={onSubmitClick}
            busy={submitted}
            primary={true}
            disabled={!dueDate || submitted}
          />
        </div>
      </div>
    </div>
  )
}

export default MoveToCsModalUI